module.exports = __webpack_public_path__ + "img/pic-1-2.35fb67a6.png";